import { Field, Form, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
var SelectHardwareEAForm = observer(function (props) {
    var appStore = props.appStore, hardwareStore = props.hardwareStore, summaryStore = props.summaryStore, checkAddressStore = props.checkAddressStore, values = props.values;
    var _a = props.planStore.planDetails.formValues, contractCode = _a.contractCode, includeVoipBundle = _a.includeVoipBundle, planType = _a.planType;
    var hardwares = hardwareStore.eligibleModems(contractCode, includeVoipBundle);
    React.useEffect(function () {
        summaryStore.getSummary(summaryStore.contractCode, values.hardwareCode, checkAddressStore.nbnLocId, summaryStore.voipCode, null);
    }, [values.hardwareCode]);
    return (React.createElement(Form, null,
        React.createElement("div", { className: "row select-hardware" },
            hardwares.map(function (h) { return (React.createElement("label", { className: "pod checkbox" + (values.hardwareCode === h.code ? ' active' : ''), key: h.code },
                React.createElement(Field, { type: "radio", name: "hardwareCode", value: h.code, checked: values.hardwareCode === h.code }),
                React.createElement("h3", { className: "pod-title" },
                    h.name,
                    ' ',
                    planType === 'Personal' && (React.createElement("span", { className: "price" },
                        "$",
                        (h.currentPricing['sellInc'] / 100).toFixed(2)))),
                React.createElement("small", { className: "label" },
                    React.createElement("img", { src: "/img/hardware/" + h.code + ".png", alt: h.code })),
                React.createElement("p", { className: "description" }, h.description))); }),
            planType === 'Personal' && (React.createElement(React.Fragment, null,
                React.createElement("label", { className: "col-12 checkbox" + (values.hardwareCode === '' ? ' active' : '') },
                    React.createElement(Field, { type: "radio", name: "hardwareCode", id: "hardwareCode", value: "", checked: values.hardwareCode === '' }),
                    React.createElement("small", { className: "label" },
                        "I already have a",
                        ' ',
                        checkAddressStore.providerCode === 'Uniti' ? 'Fibre' : 'nbn™',
                        ' ',
                        "compatible modem"),
                    React.createElement("p", { className: "description" },
                        "Please refer to your modem manufacturer and ensure your modem is compatible with the",
                        ' ',
                        checkAddressStore.providerCode === 'Uniti' ? 'Fibre' : 'nbn™',
                        ' ',
                        "technology available at your premises")),
                React.createElement("div", { className: "ml-5 mt-2" },
                    React.createElement("div", { className: "alert alert-info", role: "alert" },
                        React.createElement("p", null, "When switching providers, you may also be required to update your connection settings when switching from another provider."),
                        React.createElement("p", null,
                            "If you switch from another provider and using a BYO modem, we may be limited in performing our standard testing to check if your",
                            ' ',
                            React.createElement("strong", null, checkAddressStore.providerCode === 'Uniti'
                                ? 'fibre'
                                : 'nbn™'),
                            ' ',
                            "service is working properly.",
                            ' ')))))),
        React.createElement("section", { className: "footer-buttons" },
            React.createElement("button", { type: "button", className: "btn btn-shade btn-back", onClick: appStore.previousStep }, "Back"),
            React.createElement("button", { type: "submit", className: "btn btn-next", disabled: summaryStore.loading }, "Next"))));
});
export var SelectHardwareEA = inject('appStore', 'hardwareStore', 'planStore', 'summaryStore', 'checkAddressStore', 'saleStore')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.hardwareStore.setDetailsFromForm(values);
        bag.props.appStore.nextStep();
    },
    mapPropsToValues: function (_a) {
        var hardwareStore = _a.hardwareStore, planStore = _a.planStore, summaryStore = _a.summaryStore;
        var _b = planStore.planDetails.formValues, planType = _b.planType, contractCode = _b.contractCode, includeVoipBundle = _b.includeVoipBundle;
        var code = {
            Personal: '',
            Business: 'MODH1600-BUNDLE',
        }[planType];
        var hardwares = hardwareStore.eligibleModems(contractCode, includeVoipBundle);
        return hardwares.some(function (h) { return h.code === summaryStore.hardwareCode; })
            ? hardwareStore.hardwareDetails.formValues
            : { hardwareCode: code };
    },
})(SelectHardwareEAForm));
//# sourceMappingURL=SelectHardwareEA.js.map